(function autoCloseDetails() {
  // NEURO HORIZON FORK (#63/#320 — DO NOT drop on re-sync): stock Horizon's auto-close-details.js
  // used a single document-level `click` listener; see below for why that fails on iOS.
  //
  // Dismiss opt-in <details data-auto-close-details="desktop,mobile"> per the project's
  // mobile-interaction guidelines (docs/mobile-interaction-guidelines.md):
  //  - Close on the pointer-UP event, never pointer-down (WCAG 2.5.2 Pointer Cancellation),
  //    and only when the pointer barely moved since pointer-down — so a SCROLL/DRAG does not
  //    dismiss: a scroll moves past the slop and is ignored, and on iOS it typically fires
  //    pointercancel (not pointerup) anyway, so this pointerup handler is simply never
  //    reached. There is intentionally no pointercancel handler — none is needed.
  //  - Use pointer events, not `click`: on iOS Safari a tap on a non-interactive element
  //    (heading, image, blank space) never fires a bubbling `click`, so a click listener
  //    misses outside taps that land on ordinary content.
  //  - Escape also dismisses (keyboard parity). Filters/sorting (facets.js) and accordions
  //    (accordion-custom.js) carry their own Escape handlers too; the overlap is benign —
  //    removing `open` from an already-closed <details> is a no-op.
  //  - A gesture INSIDE an open control is left alone (so it can toggle / its links work).
  // The attribute value lists the breakpoint(s) it applies at; split is MOBILE_BREAKPOINT_PX.
  var TAP_SLOP = 10; // px of movement still counted as a tap (above this = scroll/drag)
  var MOBILE_BREAKPOINT_PX = 750; // matches the theme's mobile-first CSS breakpoint
  var downX = 0;
  var downY = 0;

  function openOptIns() {
    return Array.prototype.slice.call(
      document.querySelectorAll('details[data-auto-close-details][open]')
    );
  }

  function appliesHere(element) {
    var breakpoint = window.innerWidth < MOBILE_BREAKPOINT_PX ? 'mobile' : 'desktop';
    return (element.getAttribute('data-auto-close-details') || '').indexOf(breakpoint) !== -1;
  }

  document.addEventListener('pointerdown', function (event) {
    downX = event.clientX;
    downY = event.clientY;
  });

  document.addEventListener('pointerup', function (event) {
    if (Math.abs(event.clientX - downX) > TAP_SLOP || Math.abs(event.clientY - downY) > TAP_SLOP) {
      return; // pointer moved → scroll/drag, not a tap
    }
    openOptIns().forEach(function (element) {
      if (!appliesHere(element)) return;
      if (event.target instanceof Node && element.contains(event.target)) return; // tap inside
      element.removeAttribute('open');
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' && event.key !== 'Esc') return;
    openOptIns().forEach(function (element) {
      if (appliesHere(element)) element.removeAttribute('open');
    });
  });
})();
